export const currentProjectInspectionTemplates = (state) => {
  return state.currentProjectInspectionTemplates;
};

export const currentProjectActiveInspectionTemplates = (state) => {
  return state.currentProjectInspectionTemplates.filter((t) => !t.archived);
};

export const currentProjectInspectionTemplatesById = (state) => (id) => {
  return state.currentProjectInspectionTemplates.find(({ _id }) => _id === id);
};



// WEBPACK FOOTER //
// ./src/store/inspection/inspectionTemplateGetters.js